export const Preloader = () => (
  <div className="container mx-auto py-4">
    <p className="text-center font-semibold">Загрузка...</p>
  </div>
)
